(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9135],{

/***/ 23646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Anchor; }
});

// UNUSED EXPORTS: isTrivialHref

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js
var esm_useCommittedRef = __webpack_require__(92029);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var esm_useEventCallback = __webpack_require__(78146);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventListener.js



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = useEventCallback(listener);
  useEffect(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = useCallback(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useInterval.js


/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

function useInterval(fn, ms, paused, runImmediately) {
  if (paused === void 0) {
    paused = false;
  }

  if (runImmediately === void 0) {
    runImmediately = false;
  }

  var handle;
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  var tick = function tick() {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  var schedule = function schedule() {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };

  useEffect(function () {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }

    return function () {
      return clearTimeout(handle);
    };
  }, [paused, runImmediately]);
}

/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useRafInterval.js



function useRafInterval(fn, ms, paused) {
  if (paused === void 0) {
    paused = false;
  }

  var handle;
  var start = new Date().getTime();
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  function loop() {
    var current = new Date().getTime();
    var delta = current - start;
    if (pausedRef.current) return;

    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }

    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }

  useEffect(function () {
    handle = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(handle);
    };
  }, []);
}

/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeState.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var updater = useCallback(function (update) {
    if (update === null) return;

    if (typeof update === 'function') {
      setState(function (state) {
        var nextState = update(state);
        return nextState == null ? state : _extends({}, state, nextState);
      });
    } else {
      setState(function (state) {
        return _extends({}, state, update);
      });
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
      state = _useMergeState[0],
      setState = _useMergeState[1];

  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(88833);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useImage.js


/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  var _useState = useState({
    image: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!imageOrUrl) return undefined;
    var image;

    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;

      if (image.complete && image.naturalHeight > 0) {
        setState({
          image: image,
          error: null
        });
        return;
      }
    }

    function onLoad() {
      setState({
        image: image,
        error: null
      });
    }

    function onError(error) {
      setState({
        image: image,
        error: error
      });
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return function () {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

var isReactNative = typeof __webpack_require__.g !== 'undefined' && // @ts-ignore
__webpack_require__.g.navigator && // @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */

/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useResizeObserver.js


var targetMap = new WeakMap();
var resizeObserver;

function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}
/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */


function useResizeObserver(element) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, function (rect) {
      setRect(rect);
    });
    return function () {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/index.js














// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(70861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const _excluded = ["onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-has-content */




function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps] = (0,Button/* useButtonProps */.FT)(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = (0,esm_useEventCallback/* default */.Z)(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });

  if (isTrivialHref(props.href) && !props.role || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);

/***/ }),

/***/ 19694:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/[slug]",
      function () {
        return __webpack_require__(9630);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 9630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/branchpage.module.scss
var branchpage_module = __webpack_require__(58672);
var branchpage_module_default = /*#__PURE__*/__webpack_require__.n(branchpage_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/SeveneasySteps.tsx
var SeveneasySteps = __webpack_require__(36596);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(50282);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Ratio.js
var Ratio = __webpack_require__(84883);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/LazyMedia/index.tsx
var LazyMedia = __webpack_require__(37462);
;// CONCATENATED MODULE: ./components/BranchPage.tsx



















const Branchpage = (props)=>{
    const router = (0,next_router.useRouter)();
    const branchDetails = props.branchData[0];
    const scrollRef = (0,react.useRef)(null);
    const getBranchName = (branchName)=>{
        if (branchName.includes("(")) {
            const regExp = /\(([^)]+)\)/;
            const matches = regExp.exec(branchName);
            const cityName = branchName.split("(")[0];
            return matches && matches?.length > 0 ? matches[1] + " " + cityName : "";
        } else return branchName;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "branchheading",
                className: (branchpage_module_default()).edtech,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (branchpage_module_default()).breadcrum,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 10,
                                    md: 12,
                                    sm: 12,
                                    xs: 12,
                                    className: (branchpage_module_default()).centered,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                    style: {
                                                        opacity: 0.5
                                                    },
                                                    href: "/",
                                                    children: "Home"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default.Item */.Z.Item, {
                                                    href: "",
                                                    children: [
                                                        branchDetails?.city,
                                                        " Branch"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (branchpage_module_default()).abttopContent,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (branchpage_module_default()).abttopContentdesk,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                    children: [
                                                        "KC Overseas Education ",
                                                        branchDetails?.city,
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        " ",
                                                        branchDetails?.area && branchDetails.area,
                                                        " "
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                sm: 12,
                                xs: 12,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (branchpage_module_default()).centerContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We value your career aspirations, which is why we map your preferences with the best that our global universities have to offer. Thousands of our students are pursuing their programs and aspirations in eminent universities globally and we welcome you to pursue yours!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                "For more information connect with the leading study abroad consultant in ",
                                                getBranchName(branchDetails?.city),
                                                " ."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (branchpage_module_default()).btcontainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        sm: 12,
                                                        xs: 12,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: branchDetails?.meta?.jotforms[0]?.jotformid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: "primary",
                                                                size: "lg",
                                                                className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(branchDetails?.meta?.jotforms[0]?.jotformid)} ${(branchpage_module_default()).btInquiry}`,
                                                                children: "Enquire Now"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: "primary",
                                                                size: "lg",
                                                                className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)("university-pages-open-enquiry-form")} ${(branchpage_module_default()).btInquiry}`,
                                                                children: "Enquire Now"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        sm: 12,
                                                        xs: 12,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (branchpage_module_default()).btBranchaddress,
                                                            onClick: ()=>scrollRef?.current?.scrollIntoView(),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                    src: "/new-images/bt-branch-address.svg",
                                                                    alt: "Bt_BranchAddress",
                                                                    width: 48,
                                                                    height: 48
                                                                }),
                                                                "Branch Address"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "popular-universities",
                className: (branchpage_module_default()).popularUniversities,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Services we provide"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/test-icon.svg",
                                                            alt: "testIcon",
                                                            width: 24,
                                                            height: 30
                                                        }),
                                                        "Test Preparation & Coaching"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/app-icon.svg",
                                                            alt: "appIcon",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Application Assistance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/edu-icon.svg",
                                                            alt: "eduIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Education Loan & Fee Payments"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/stud-icon.svg",
                                                            alt: "studIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Student Visa Assistance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/travel.svg",
                                                            alt: "preDepIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Travel Assistance"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xs: 12,
                                        lg: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/course-icon-a.svg",
                                                            alt: "courseIcon.svg",
                                                            width: 25,
                                                            height: 30
                                                        }),
                                                        "Course, Country & University Selection"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/schol-icon.svg",
                                                            alt: "scholIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Scholarship Assistance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/accommodation.svg",
                                                            alt: "insuIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Accommodation Assistance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/insu-icon.svg",
                                                            alt: "insuIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Insurance, Forex & Remittance Assistance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/pre-dep-icon.svg",
                                                            alt: "preDepIcon.svg",
                                                            width: 30,
                                                            height: 30
                                                        }),
                                                        "Pre-Departure Orientation"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: branchDetails?.meta?.jotforms[0]?.jotformid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "primary",
                                        size: "lg",
                                        className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(branchDetails?.meta?.jotforms[0]?.jotformid)} ${(branchpage_module_default()).btInquiry}`,
                                        children: "Enquire Now"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "primary",
                                        size: "lg",
                                        className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)("university-pages-open-enquiry-form")} ${(branchpage_module_default()).btInquiry}`,
                                        children: "Enquire Now"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "studycntbranch",
                className: (branchpage_module_default()).studyContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: "/realize.svg",
                                    alt: "realize.svg",
                                    width: 490,
                                    height: 440
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (branchpage_module_default()).contentAlign,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (branchpage_module_default()).offers,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Realize your global ambitions with us"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "With a keen ear for your choices and preferences, our counselling experience is so seamless that you will land in your dream university even before you do!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Virtual & In Person Coaching and Counselling"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Comprehensive Assistance for Applications, Admissions & Visas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "High Value Scholarships and Study Loans"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            branchDetails?.testimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "videobranch",
                style: {
                    backgroundColor: `${branchDetails.testimonial?.sectionBgColor}`
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: (branchpage_module_default()).videobranch,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 12,
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-5",
                                    children: branchDetails.testimonial?.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 12,
                                className: "text-center position-relative mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (branchpage_module_default()).videoBase,
                                        style: {
                                            backgroundColor: `${branchDetails.testimonial?.videoBgColor}`
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (branchpage_module_default()).videoPlaceholder,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratio/* default */.Z, {
                                            aspectRatio: "16x9",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                                tag: "embed",
                                                type: "image/svg+xml",
                                                src: branchDetails.testimonial?.videoLink
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "uni-tieup",
                className: (branchpage_module_default()).uniTieUp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            lg: 12,
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (branchpage_module_default()).uniDiv,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Take your first step with KC"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (branchpage_module_default()).uniDiv,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Test Preparation"
                                                }),
                                                router.asPath.includes("contact-us/study-abroad-consultants-in-raipur") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Welcome to KC Academy’s IELTS Coaching in Raipur! We provide highly motivated and skilled tutors, who have over two decades of expertise of driving thousands of ambitious test seekers like you to excellence. Our students routinely achieve top test scores, thanks to the exceptional tutoring by our passionate and accomplished faculties and our test prep methodologies that are highly effective, yet are easy, interactive & fun. Get the score you are aiming for SAT, ACT, GRE, GMAT, TOEFL, PTE, and IELTS classes. Enrol with us for test preparation coaching in Raipur."
                                                }) || /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Reach your highest potential test score effortlessly with the exceptional tutoring of our passionate and accomplished tutors and our highly effective and engaging test prep methodologies."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (branchpage_module_default()).offers,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Offerings"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Access top quality test-prep material"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Interactive online audio/video content"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Small class sizes – personalized attention"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Rich database of practice questions"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Mock tests simulating real test environment"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        branchDetails?.meta?.jotforms[0]?.jotformid ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(branchDetails?.meta?.jotforms[0]?.jotformid)} ${(branchpage_module_default()).btInquiryNobg}`,
                                            children: "Enquire Now"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: `${(0,helpers/* isFrappeOrJotFormClass */.gd)("university-pages-open-enquiry-form")} ${(branchpage_module_default()).btInquiryNobg}`,
                                            children: "Enquire Now"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (branchpage_module_default()).firstStep,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: `${(branchpage_module_default()).cols} ${(branchpage_module_default()).borderl0}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/ieltslogo.svg",
                                                            alt: "ieltslogo.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: (branchpage_module_default()).cols,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/etstofel.svg",
                                                            alt: "etstofel.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: `${(branchpage_module_default()).cols} ${(branchpage_module_default()).borderl0}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/pearson.svg",
                                                            alt: "pearson.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: (branchpage_module_default()).cols,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/act.svg",
                                                            alt: "act.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: `${(branchpage_module_default()).cols} ${(branchpage_module_default()).borderl0}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/gmat-icon.svg",
                                                            alt: "gMat.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 6,
                                                    md: 6,
                                                    xs: 6,
                                                    className: `${(branchpage_module_default()).cols} `,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/ets-gre.svg",
                                                            alt: "/new-images/ets-gre.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    xl: 12,
                                                    md: 12,
                                                    xs: 12,
                                                    className: `${(branchpage_module_default()).cols} ${(branchpage_module_default()).border0} ${(branchpage_module_default()).borderl0}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (branchpage_module_default()).unidiv,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/sat-ets.svg",
                                                            alt: "SATETS.svg",
                                                            width: 157,
                                                            height: 75
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "kcedge",
                className: (branchpage_module_default()).kcedge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            lg: 12,
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-center mb-5",
                                children: "The KC Edge"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    className: (branchpage_module_default()).partnerSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/new-images/tie-ups.svg",
                                                width: 105,
                                                height: 75,
                                                alt: "tieUps"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "47 Countries & 1200+ University Tie-ups"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "The choices are endless and we are there to suggest you what suits you the most."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    className: (branchpage_module_default()).partnerSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/new-images/the-way.svg",
                                                width: 105,
                                                height: 75,
                                                alt: "theWay"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Supporting you all the way"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "From the day you consult us till the day you land in your dream university; we will support you all the way and by all means!"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    className: (branchpage_module_default()).partnerSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: "/new-images/speak-vol.svg",
                                                width: 105,
                                                height: 75,
                                                alt: "speakVol"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "Our numbers speak volumes"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "5,30,000+ students have benefited from our counselling & services, and we will be happy to help you reach your academic & career goals."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (branchpage_module_default()).sevenSetpesBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeveneasySteps/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                    headingLevel: 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our students love us",
                bgColor: "#FFFFFF",
                slug: `student-testimonials?_limit=15&_sort=id:DESC`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (branchpage_module_default()).homePageLatestKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (branchpage_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "office-address",
                className: (branchpage_module_default()).officeAddress,
                ref: scrollRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: (branchpage_module_default()).row,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                lg: 6,
                                md: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (branchpage_module_default()).offices,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: (branchpage_module_default()).DesktopViewHeading,
                                            id: "desktopBranch",
                                            children: [
                                                "KC Overseas Education: ",
                                                branchDetails?.city
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(branchpage_module_default()).contactDetail} ${(branchpage_module_default()).addDisplay}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).addImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/images/contcatus/addressiconcontact.svg",
                                                        alt: "contact-location",
                                                        width: 40,
                                                        height: 40,
                                                        className: (branchpage_module_default()).img
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).content,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: branchDetails?.address
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(branchpage_module_default()).contactDetail} ${(branchpage_module_default()).addDisplay}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).addImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/images/contcatus/mobileiconcontact.svg",
                                                        alt: "contact-location",
                                                        width: 40,
                                                        height: 40,
                                                        className: (branchpage_module_default()).img
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).content,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (branchpage_module_default()).para,
                                                        children: branchDetails?.mobile
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(branchpage_module_default()).contactDetail} ${(branchpage_module_default()).addDisplay}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).addImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/images/contcatus/emailiconcontcat.svg",
                                                        alt: "contact-email",
                                                        width: 40,
                                                        height: 40,
                                                        className: (branchpage_module_default()).img
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).content,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (branchpage_module_default()).para,
                                                        children: branchDetails?.email
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(branchpage_module_default()).contactDetail} ${(branchpage_module_default()).addDisplay}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).addImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/images/contcatus/timingiconcontact.svg",
                                                        alt: "contcat-clock",
                                                        width: 40,
                                                        height: 40
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (branchpage_module_default()).content,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (branchpage_module_default()).para,
                                                        children: branchDetails?.timings
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            branchDetails?.embedLocationUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                lg: 6,
                                md: 6,
                                xs: 12,
                                className: "mb-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: (branchpage_module_default()).mobileHeading,
                                        id: "mobileBranch",
                                        children: [
                                            "KC Overseas Education: ",
                                            branchDetails?.city
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (branchpage_module_default()).map,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMedia/* default */.Z, {
                                            width: "100%",
                                            height: "480px",
                                            src: branchDetails?.embedLocationUrl,
                                            tag: "iframe"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            branchDetails?.socialMediaLinks && branchDetails.socialMediaLinks.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (branchpage_module_default()).BranchSocialMedia,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (branchpage_module_default()).socialMedia,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (branchpage_module_default()).socialMediaDiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (branchpage_module_default()).socialMediaLinks,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: branchDetails.socialMediaTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: (branchpage_module_default()).row,
                                        children: branchDetails.socialMediaLinks.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                className: (branchpage_module_default()).col,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                    data: link,
                                                    alt: link.image?.alternativeText || link.image?.name,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: link.image?.url || "/",
                                                        alt: link.image?.alternativeText || link.image?.name,
                                                        width: 40,
                                                        height: 40
                                                    })
                                                })
                                            }, link.id))
                                    })
                                ]
                            })
                        })
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var BranchPage = (Branchpage);

// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./pages/contact-us/[slug].tsx






const Brnchpage = (props)=>{
    if (!props.branchData || props.branchData.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    const { meta  } = props.branchData[0];
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6c48f0");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    const updatedMeta = meta?.jotforms?.length === 0 ? {
        ...meta,
        jotforms: constants/* commonJotformScript */.Y4
    } : {
        ...meta
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            updatedMeta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...updatedMeta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BranchPage, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Brnchpage);


/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ }),

/***/ 58672:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"abttopContent":"branchpage_abttopContent__PjEc9","abttopContentdesk":"branchpage_abttopContentdesk__cbbFi","abttopContentMobile":"branchpage_abttopContentMobile__UaxQ5","sectionBorder":"branchpage_sectionBorder__o0EfB","btcontainer":"branchpage_btcontainer__Xt3nY","btInquiry":"branchpage_btInquiry__YTtaw","btBranchaddress":"branchpage_btBranchaddress__xb_Sm","btInquiryNobg":"branchpage_btInquiryNobg__z3pgu","centerContent":"branchpage_centerContent__1UIiG","edtech":"branchpage_edtech__osvyn","breadcrum":"branchpage_breadcrum__DYdq6","enquirebtn":"branchpage_enquirebtn__DJoAB","heading":"branchpage_heading__qlu7C","buttongp":"branchpage_buttongp__b7g3U","kcbtn":"branchpage_kcbtn__ZwRZp","centered":"branchpage_centered__4Waz_","breadcrumb-item":"branchpage_breadcrumb-item__7OmgI","active":"branchpage_active__mdT1J","hideimg":"branchpage_hideimg__QsFiq","rowPadding":"branchpage_rowPadding__sQopy","viewMore":"branchpage_viewMore__5g6gw","learnText":"branchpage_learnText__j_TzJ","iconSetting":"branchpage_iconSetting__b1ZZv","homePageLatestKcUpdates":"branchpage_homePageLatestKcUpdates__Fdqaf","homePageBlogs":"branchpage_homePageBlogs__5FSFu","studyContent":"branchpage_studyContent__UCMS2","contentAlign":"branchpage_contentAlign__TulK5","studyAnchor":"branchpage_studyAnchor__JH_uY","indusContent":"branchpage_indusContent__sJH0X","popularUniversities":"branchpage_popularUniversities__Sam4M","popularCourses":"branchpage_popularCourses__QW_vO","containerSpace":"branchpage_containerSpace__lDyjd","morelink":"branchpage_morelink__r0zQI","costofEducation":"branchpage_costofEducation__LF9fB","recogTabs":"branchpage_recogTabs__9pTgb","headtr":"branchpage_headtr__88C4S","headsmalltr":"branchpage_headsmalltr__1j3MM","customtr":"branchpage_customtr__OB85Z","studentTestSlider":"branchpage_studentTestSlider__Z2iWa","uniTieUp":"branchpage_uniTieUp__aWnin","cols":"branchpage_cols__ClqTp","borderl0":"branchpage_borderl0__vLmGZ","border0":"branchpage_border0__zwSx4","firstStep":"branchpage_firstStep__cKJw3","officeAddress":"branchpage_officeAddress__sdehU","showMap":"branchpage_showMap__tfpSl","offices":"branchpage_offices__THbWJ","contactDetail":"branchpage_contactDetail__4Pwkz","addDisplay":"branchpage_addDisplay__CcEJR","content":"branchpage_content__X_KJA","para":"branchpage_para__SX9pY","addImg":"branchpage_addImg__GZ5w0","imgl":"branchpage_imgl__DV07K","map":"branchpage_map__Vftdg","mobileAnchor":"branchpage_mobileAnchor__3uu4T","row":"branchpage_row__tln1n","DesktopViewHeading":"branchpage_DesktopViewHeading__LeGQ_","mobileHeading":"branchpage_mobileHeading__NXg6K","BranchSocialMedia":"branchpage_BranchSocialMedia__FuDYk","socialMedia":"branchpage_socialMedia__k5Jce","socialMediaDiv":"branchpage_socialMediaDiv__HDt8Q","socialMediaLinks":"branchpage_socialMediaLinks__c0jGg","col":"branchpage_col__ZhoUx","kcedge":"branchpage_kcedge__Ksvu9","partnerSection":"branchpage_partnerSection__l7XTG","bgstudentslove":"branchpage_bgstudentslove__Gve_B","sevenSetpesBg":"branchpage_sevenSetpesBg__etcFQ","videobranch":"branchpage_videobranch__BPkBj","videoPlaceholder":"branchpage_videoPlaceholder__r9Slz","videoBase":"branchpage_videoBase__ULPgZ"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ }),

/***/ 84883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  aspectRatio: '1x1'
};

function toPercent(num) {
  if (num <= 0 || num > 100) return '100%';
  if (num < 1) return `${num * 100}%`;
  return `${num}%`;
}

const Ratio = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  children,
  aspectRatio,
  style,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'ratio');
  const isCustomRatio = typeof aspectRatio === 'number';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    ref: ref,
    ...props,
    style: { ...style,
      ...(isCustomRatio && {
        '--bs-aspect-ratio': toPercent(aspectRatio)
      })
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children)
  });
});
Ratio.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Ratio);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,3656,5684,9465,2350,3593,1437,9774,2888,179], function() { return __webpack_exec__(19694); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);